import { render, staticRenderFns } from "./senior-modal.vue?vue&type=template&id=4c1dc96a&scoped=true&"
import script from "./senior-modal.vue?vue&type=script&lang=js&"
export * from "./senior-modal.vue?vue&type=script&lang=js&"
import style0 from "./senior-modal.vue?vue&type=style&index=0&id=4c1dc96a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1dc96a",
  null
  
)

export default component.exports